import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

export const CopilotEmptyState: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View style={styles.pill}>
      <Typography size="$sm" textAlign="center">
        {i18n.t('sales_portal.copilot.empty')}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  pill: {
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: theme.sk.radii.radiusMedium,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
    width: '100%',
  },
}));
